import {IAttributes, IRootElementService, IScope} from "angular";

export const TfVisible = "tfVisible";

const CLASS_NAME = "tf-invisible";

export function tfVisible() {
    return {
        restrict: "A",
        multiElement: true,
        link($scope: IScope, $elem: IRootElementService, $attr: IAttributes) {
            $scope.$watch($attr.tfVisible, (value: boolean) => {
                if (value) {
                    $elem.removeClass(CLASS_NAME);
                } else {
                    $elem.addClass(CLASS_NAME);
                }
            });
        }
    };
}
